import { MarketplaceApp } from './components/marketplace/MarketplaceApp';

export default function App() {
  return <MarketplaceApp />;
}
